import { MusicCircleIcon } from './MusicCircleIcon';

/**
 * author: Austin Andrews
 * id 33A79A85-7985-4E08-8AA8-D6242A9C2700
 * name music-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-circle.svg
 * tags
 * - Audio 
 * - Music 
 */
export const NoteCircleIcon = MusicCircleIcon;
export default NoteCircleIcon